import React, {forwardRef} from 'react';
import {View} from 'react-native';
import Popup from '../../../utils/mockedWebLibs/reactjs-popup';
import {useTheme, useThemedStyles} from '../../../theme';
import makeStyles from './styles';
import {VerticalDotsIcon} from '../../../utils/SvgIcons';

const WebPopupMenu = forwardRef(({children, ...props}, ref) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <Popup
      ref={ref}
      trigger={
        <View style={styles.menuIconContainer}>
          <VerticalDotsIcon
            width={5}
            height={16}
            tintColor={colors.textPrimary}
          />
        </View>
      }
      position="right center"
      arrow={false}
      contentStyle={styles.content}
      {...props}
    >
      {children}
    </Popup>
  );
});

export default WebPopupMenu;
